export default __webpack_public_path__ + "static/media/abstracto4768.7976ef7e.jpg";